import dataScroll from "helpers/dataScroll";
import objectFitImages from "object-fit-images";

window.addEventListener("DOMContentLoaded", () => {
  dataScroll();

  // Lazy load images
  [].forEach.call(document.querySelectorAll("img[data-src]"), (t) => {
    t.setAttribute("src", t.getAttribute("data-src"));
    t.onload = () => {
      t.removeAttribute("data-src");
    };
  });

  // Polyfill for object-fit-images
  objectFitImages(".js-image-text-img");
});
